// @third-party-packages
import React from 'react';
import { useState, useCallback, useEffect } from 'react';

import { get } from '@services/method';
import { TableColumn } from '@components/HOCTable/Columns/Column';

export interface TableConfiguration {
  api: {
    get: string;
  } | null;
  localData?: any;
  sortedBy: string | null;
  columns: string[];
}

export interface TableReturnState {
  status: number;
  data: [] | any;
  columns: JSX.Element;
  sort: Function;
}

export const useTableHook = (config: TableConfiguration): TableReturnState => {
  // const [_initState, setInitState] = useState<TableConfiguration>(config);
  const [_status, setStatus] = useState<number>(0);
  const [_sortedBy, setSortedBy] = useState<string>('');
  const [_columns, setColumns] = useState<JSX.Element>(<></>);
  const [_data, setData] = useState<[]>([]);

  // @effect - when the (_sortedBy) state value changes
  useEffect(() => {
    if (config.api) {
      asyncLoad();
    } else if (config.localData) {
      load();
    }
    columns();
  }, [_sortedBy]);

  const _sort = useCallback((columnName) => setSortedBy(columnName), []);

  // local data
  const load = useCallback(() => {
    setData(config.localData);
    setStatus(2);
  }, []);

  // sends the request
  const asyncLoad = useCallback(async () => {
    setStatus(0);
    (async function requestTableData() {
      const response = await get(config.api!.get).then((resp) => resp.json());
      setData(response);
      setStatus(2);
    })();
  }, []);

  // builds the columns
  const columns = useCallback(() => {
    const columns: JSX.Element[] = config.columns.map((name, idx) => {
      return (
        <TableColumn
          key={idx}
          name={name}
          sort={config.sortedBy ? _sort(name) : null}
        />
      );
    });
    setColumns(<>{columns}</>);
  }, []);

  return {
    data: _data,
    sort: _sort,
    columns: _columns,
    status: _status,
  };
};
